import { from, Observable, of } from 'rxjs';
import { EnrolmentClaim } from '../../../routes/enrolment/models/enrolment-claim';
import { catchError, finalize, map, switchMap, tap } from 'rxjs/operators';
import { LoadingService } from '../../../shared/services/loading.service';

export abstract class EffectBaseAbstract {
  constructor(protected loadingService: LoadingService) {}
  protected abstract getClaim(enrolmentId: string): Observable<EnrolmentClaim>;
  protected abstract getClaims(): Observable<EnrolmentClaim[]>;

  updateEnrolment(successAction, failureAction) {
    return (source: Observable<{ id: string }>) =>
      source.pipe(
        switchMap(({ id }) =>
          from(this.getClaim(id)).pipe(
            map((updatedEnrolment: EnrolmentClaim) =>
              successAction({ enrolment: updatedEnrolment })
            ),
            catchError((e) => {
              console.error(e);
              return of(
                failureAction({
                  error: e.message,
                })
              );
            })
          )
        )
      );
  }

  protected getEnrolments(successAction, failureAction, displayLoader = true) {
    return (source: Observable<EnrolmentClaim[]>) => {
      return source.pipe(
        tap(() => {
          if (displayLoader) {
            this.loadingService.show();
          }
        }),
        switchMap(() => {
          let loaderHidden = false;
          const hideLoader = () => {
            if (displayLoader && !loaderHidden) {
              this.loadingService.hide();
              loaderHidden = true;
            }
          };

          return this.getClaims().pipe(
            map((enrolments: EnrolmentClaim[]) =>
              successAction({ enrolments })
            ),
            tap(() => hideLoader()),
            catchError((e) => {
              console.error(e);
              hideLoader();
              return of(failureAction({ error: e.message }));
            }),
            finalize(() => hideLoader())
          );
        })
      );
    };
  }
}
